import React, { memo, useState } from "react";
import classes from "./ImageView.module.css";
import ImgFrame from "../../../components/common/ImageFrame/ImgFrame";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { ArrowLeft, ArrowRight, Close, Download } from "@mui/icons-material";
import { Document, Page, pdfjs } from "react-pdf";
import { Box, Button, Modal } from "@mui/material";
import noImageAvailable from "../../../assets/images/png/no-image-available.png";
import { saveAs } from "file-saver";
import { configurePdfWorker } from "../../../utils/configurePdfWorker";

configurePdfWorker(pdfjs);

const ImageView = ({
  customClass,
  imgCustomClass,
  imgSrc,
  label,
  viewClick,
  imgFieldClass,
  widthSize,
}) => {
  // view image states
  const [documentImage, setDocumentImage] = useState();
  const [openImageFullView, setOpenImageFullView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [numPages, setNumPages] = useState(null);

  // Replace S3 URL with CloudFront URL if available
  const replaceWithCloudfront = (url) => {
    if (!url) return url;
    const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
    if (cloudfrontUrl && url.includes("https://teckost.s3.amazonaws.com")) {
      return url.replace("https://teckost.s3.amazonaws.com", cloudfrontUrl);
    }
    return url;
  };

  const handleOpenImageFullView = (imageSrc) => {
    setOpenImageFullView(true);
    const replacedUrl = replaceWithCloudfront(imageSrc);
    setDocumentImage(replacedUrl || noImageAvailable);
    if (imageSrc && imageSrc.endsWith(".pdf")) {
      setCurrentPage(1);
    }
  };

  // "https://github.githubassets.com/images/modules/profile/badge--acv-64.png"
  async function downloadimg(url, fileName) {
    const replacedUrl = replaceWithCloudfront(url);
    const a = document.createElement("a");
    a.href = await toDataURL(replacedUrl);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function toDataURL(url) {
    const replacedUrl = replaceWithCloudfront(url);
    return fetch(replacedUrl)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  }

  function DownloadImage(src, fileName) {
    downloadimg(src, fileName);
  }

  const closeViewImagePopup = () => {
    setOpenImageFullView(false);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < numPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  let sourcename = imgSrc && imgSrc?.split("/");
  let fileName = sourcename[sourcename?.length - 1];

  let sourceExtension = imgSrc && imgSrc.split(".");
  let extension = sourceExtension[sourceExtension.length - 1];

  return (
    <div
      className={`${classes?.imgViewWrapper || ""} ${customClass || ""}`}
      style={{
        width: widthSize || "100px",
      }}
    >
      <div className={`${classes.imgField} ${imgFieldClass}`}>
        <RemoveRedEyeIcon
          className={classes.viewfullImageIcon}
          onClick={() => {
            handleOpenImageFullView(imgSrc);
          }}
        />
        <Download
          className={classes.downloadFileIcon}
          sx={{
            fontSize: "1.8rem",
          }}
          onClick={() => {
            DownloadImage(imgSrc, fileName)
            // saveAs(imgSrc, fileName);
          }}
        />
        {extension === "pdf" ? (
          <div style={{ width: "100%" }}>
            <Document
              file={replaceWithCloudfront(imgSrc)}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            >
              <Page pageNumber={1} />
            </Document>
          </div>
        ) : extension === "png" ||
          extension === "jpeg" ||
          extension === "jpg" ? (
          <ImgFrame imgSrc={replaceWithCloudfront(imgSrc)} customClass={imgCustomClass} />
        ) : (
          ""
        )}
      </div>
      <p className={classes.label}>{label}</p>

      {/* view full image popup */}
      <Modal
        open={openImageFullView}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "90vh",
          }}
        >
          <div className={classes.fullImageViewWrap}>
            <Close
              className={classes.closeBtn}
              onClick={() => {
                closeViewImagePopup();
              }}
            />
            <div className={classes.fullImageView}>
              {extension === "pdf" ? (
                <div className={classes.pdfWrapper}>
                  <p>{fileName}</p>
                  <Document
                    file={replaceWithCloudfront(imgSrc)}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  >
                    <Page
                      pageNumber={currentPage}
                      className={classes.pdfPage}
                    />
                  </Document>
                  <div className={classes.pdfBtn}>
                    <p>
                      {currentPage} - {numPages} Pages
                    </p>
                    <div className={classes.flex}>
                      <Button
                        className={classes.button}
                        onClick={handlePrevPage}
                      >
                        <ArrowLeft
                          sx={{
                            fontSize: "2.4rem",
                            color: "#000",
                          }}
                        />
                      </Button>
                      <Button
                        className={classes.button}
                        onClick={handleNextPage}
                      >
                        <ArrowRight
                          sx={{
                            fontSize: "2.4rem",
                            color: "#000",
                          }}
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <img
                  src={documentImage}
                  alt="Full View"
                  className={classes.fullImage}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default memo(ImageView);
